import React from "react";
import {
    UserOutlined,
    MailOutlined,
    PhoneOutlined,
    BankOutlined,
    CheckCircleOutlined,
    CloseCircleOutlined,
    InfoCircleOutlined
} from "@ant-design/icons";
import { Col, Row, Tag } from "antd";
import CommonCard from "../../../../global/card";
import { cn } from "../../../../../utils/cn";

const EnhancedLowActivityUsersDetails = ({
    userDetail,
}) => {
    if (!userDetail) return null;

    const getIconForField = (label) => {
        const iconMap = {
            "Name": <UserOutlined />,
            "Email": <MailOutlined />,
            "Phone": <PhoneOutlined />,
            "Company": <BankOutlined />,
            "Verified": <CheckCircleOutlined /> // Or CloseCircle depending on value, handled in render
        };
        return iconMap[label] || <InfoCircleOutlined />;
    };

    return (
        <div className="p-6" style={{ backgroundColor: "#f5f7fa" }}>
            <CommonCard>
                <Row gutter={[48, 24]}>
                    {/* User Info */}
                    <Col span={12} className="border-r border-gray-100">
                        <div className="flex items-center gap-2 mb-6">
                            <UserOutlined style={{ color: "var(--primary-color, #1890ff)", fontSize: "18px" }} />
                            <span style={{ fontSize: "16px", fontWeight: 600 }}>User Information</span>
                        </div>
                        {[
                            { label: "Name", value: userDetail?.name || "N/A" },
                            { label: "Email", value: userDetail?.email },
                            {
                                label: "Verified",
                                value: (
                                    <Tag color={userDetail?.verified === "y" ? "success" : "error"}>
                                        {userDetail?.verified === "y" ? "Verified" : "Not Verified"}
                                    </Tag>
                                ),
                                isComponent: true
                            },
                        ].map((item, idx) => (
                            <div key={item.label} className={cn("flex justify-between items-center w-full py-4 border-b border-gray-100", idx === 2 && "!border-b-0")}>
                                <span className="text-sm text-gray-600 flex items-center gap-2 font-medium">
                                    <span style={{ color: "var(--primary-color, #1890ff)", fontSize: "16px" }}>
                                        {getIconForField(item.label)}
                                    </span>
                                    {item.label}
                                </span>
                                <span className="text-sm font-semibold text-gray-900">
                                    {item.isComponent ? item.value : (item.value || "—")}
                                </span>
                            </div>
                        ))}
                    </Col>

                    {/* Contact Info */}
                    <Col span={12} className="pl-6">
                        <div className="flex items-center gap-2 mb-6">
                            <BankOutlined style={{ color: "var(--primary-color, #1890ff)", fontSize: "18px" }} />
                            <span style={{ fontSize: "16px", fontWeight: 600 }}>Contact Details</span>
                        </div>
                        {[
                            { label: "Phone", value: userDetail?.phone || "N/A" },
                            { label: "Company", value: userDetail?.company || "N/A" },
                        ].map((item, idx) => (
                            <div key={item.label} className={cn("flex justify-between items-center w-full py-4 border-b border-gray-100", idx === 1 && "!border-b-0")}>
                                <span className="text-sm text-gray-600 flex items-center gap-2 font-medium">
                                    <span style={{ color: "var(--primary-color, #1890ff)", fontSize: "16px" }}>
                                        {getIconForField(item.label)}
                                    </span>
                                    {item.label}
                                </span>
                                <span className="text-sm font-semibold text-gray-900">{item.value || "—"}</span>
                            </div>
                        ))}
                    </Col>
                </Row>
            </CommonCard>
        </div>
    );
};

export default EnhancedLowActivityUsersDetails;
